var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,4.8h-3.6C16.5,3,14.7,2,12,2S7.5,3,6.9,4.8H3.3c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h0.6l0.5,13.3 C4.4,21,5.4,22,6.7,22h10.6c1.3,0,2.3-1,2.3-2.3l0.5-13.4h0.6c0.5,0,0.8-0.4,0.8-0.8C21.6,5.2,21.2,4.8,20.7,4.8z M12,3.6 c1.2,0,2.7,0.2,3.3,1.2H8.7C9.3,3.8,10.8,3.6,12,3.6z M18,19.7c0,0.4-0.3,0.7-0.7,0.7H6.7c-0.4,0-0.7-0.3-0.7-0.7L5.5,6.4h3.2 l0.3,11.9c0,0.4,0.4,0.8,0.8,0.8h0c0.5,0,0.8-0.4,0.8-0.8L10.3,6.4h3.4l-0.3,11.9c0,0.4,0.4,0.8,0.8,0.8h0c0.4,0,0.8-0.3,0.8-0.8 l0.3-11.9h3.2L18,19.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.b957302def9861d5a24d7f7220e05573.svg";
export { ForwardRef as ReactComponent };